module.exports = __webpack_public_path__ + "img/logo-glaxi.168d7bd3.svg";